/**
 * 팝업 공통 모션 — D3 §4.5. 팝업 컴포넌트는 값을 각자 적지 않고 이 상수만 참조한다.
 *
 * - 진입은 `data-[starting-style]`, 퇴장은 `data-[ending-style]`에서 출발·도착한다.
 * - 퇴장은 진입보다 한 단 짧다(`-exit` 짝 토큰 · D2 §7.2).
 * - 이동·크기는 `motion-safe:` 아래에만 둔다. reduced-motion이면 opacity만 남는다(D2 §7.4).
 * - 시작 scale은 0.95 이상이다 — 디자인 게이트가 막는다.
 */

const FADE = 'data-[starting-style]:opacity-0 data-[ending-style]:opacity-0';

/** Popover · Menu · SearchCombobox 목록 — 트리거 쪽에서 자란다(Base UI Positioner의 `--transform-origin`). */
export const anchoredPopupMotion = [
  'origin-[var(--transform-origin)] ease-flow transition-[opacity,scale]',
  'duration-fast data-[ending-style]:duration-fast-exit',
  FADE,
  'motion-safe:data-[starting-style]:scale-96 motion-safe:data-[ending-style]:scale-96',
].join(' ');

/** Select — 목록이 길어 한 단 느리게 연다. */
export const selectPopupMotion = [
  'origin-[var(--transform-origin)] ease-flow transition-[opacity,scale]',
  'duration-base data-[ending-style]:duration-base-exit',
  FADE,
  'motion-safe:data-[starting-style]:scale-96 motion-safe:data-[ending-style]:scale-96',
].join(' ');

/**
 * Tooltip — 첫 표시만 지연(Provider)·전환이 있고, 옆 트리거로 옮길 때 Base UI가 붙이는
 * `data-instant`에서는 전환 없이 바로 바뀐다.
 */
export const tooltipPopupMotion = [
  'origin-[var(--transform-origin)] ease-flow transition-[opacity,scale]',
  'duration-fast data-[ending-style]:duration-fast-exit data-[instant]:duration-0',
  FADE,
  'motion-safe:data-[starting-style]:scale-97 motion-safe:data-[ending-style]:scale-97',
].join(' ');

/** Dialog · ConfirmDialog — 모달은 트리거와 공간적으로 이어지지 않으므로 가운데에서 자란다. */
export const modalPopupMotion = [
  'origin-center ease-flow transition-[opacity,scale]',
  'duration-base data-[ending-style]:duration-base-exit',
  FADE,
  'motion-safe:data-[starting-style]:scale-96 motion-safe:data-[ending-style]:scale-96',
].join(' ');

/** Dialog · Sheet 배경막 — 팝업과 같은 시간으로 opacity만. */
export const backdropMotion = [
  'ease-flow transition-opacity',
  'duration-base data-[ending-style]:duration-base-exit',
  FADE,
].join(' ');

/** Sheet — 오른쪽 가장자리에서 미끄러져 들어온다. 곡선은 시트 전용 `ease-drawer`. */
export const sheetPopupMotion = [
  'ease-drawer transition-[opacity,translate]',
  'duration-slow data-[ending-style]:duration-slow-exit',
  'motion-reduce:data-[starting-style]:opacity-0 motion-reduce:data-[ending-style]:opacity-0',
  'motion-safe:data-[starting-style]:translate-x-full motion-safe:data-[ending-style]:translate-x-full',
].join(' ');

/** Sheet 배경막 — 시트와 같은 시간. */
export const sheetBackdropMotion = [
  'ease-drawer transition-opacity',
  'duration-slow data-[ending-style]:duration-slow-exit',
  FADE,
].join(' ');
